import galleryImage1 from '../assets/gallery/1.jpeg';
import galleryImage2 from '../assets/gallery/2.jpeg';
import galleryImage3 from '../assets/gallery/3.jpeg';
import galleryImage4 from '../assets/gallery/4.jpeg';
import galleryImage5 from '../assets/gallery/5.jpeg';
import galleryImage6 from '../assets/gallery/6.jpeg';
import galleryImage7 from '../assets/gallery/7.jpeg';
import galleryImage8 from '../assets/gallery/8.jpeg';

const galleryItems = [
  { id: 1, image: galleryImage1, href: '/gallery#photo-1' },
  { id: 2, image: galleryImage2, href: '/gallery#photo-2' },
  { id: 3, image: galleryImage3, href: '/gallery#photo-3' },
  { id: 4, image: galleryImage4, href: '/gallery#photo-4' },
  { id: 5, image: galleryImage5, href: '/gallery#photo-5' },
  { id: 6, image: galleryImage6, href: '/gallery#photo-6' },
  { id: 7, image: galleryImage7, href: '/gallery#photo-7' },
  { id: 8, image: galleryImage8, href: '/gallery#photo-8' }
];

export default galleryItems;

